"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduledPostFromPost = scheduledPostFromPost;
exports.scheduledPostToPost = scheduledPostToPost;
function scheduledPostFromPost(post, schedulingInfo) {
    return {
        id: '',
        scheduled_at: schedulingInfo.scheduled_at,
        create_at: 0,
        update_at: post.update_at,
        user_id: post.user_id,
        channel_id: post.channel_id,
        root_id: post.root_id,
        message: post.message,
        props: post.props,
        metadata: post.metadata,
        priority: post.metadata.priority,
    };
}
function scheduledPostToPost(scheduledPost) {
    const post = {
        edit_at: 0,
        hashtags: '',
        is_pinned: false,
        original_id: '',
        pending_post_id: '',
        reply_count: 0,
        type: '',
        id: scheduledPost.id,
        create_at: scheduledPost.create_at,
        update_at: scheduledPost.update_at,
        delete_at: 0,
        user_id: scheduledPost.user_id,
        channel_id: scheduledPost.channel_id,
        root_id: scheduledPost.root_id,
        message: scheduledPost.message,
        props: scheduledPost.props,
        metadata: {
            embeds: [],
            emojis: [],
            files: [],
            images: {},
        },
    };
    if (scheduledPost.metadata) {
        post.metadata = scheduledPost.metadata;
    }
    return post;
}
